/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_View_Toggle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "View toggle" |
*
* @param {Speakers_View_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_view_toggle_aria_label = /** @type {((inputs?: Speakers_View_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_View_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer la vue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ansicht umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza interruttore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить вид")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver alternar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看切换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दृश्य टॉगल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar visualização")
	return /** @type {LocalizedString} */ ("View toggle")
});